$(document).ready(function(){

  $('body').on('submit','.js-validate-form', function (e) {
    if (e.isDefaultPrevented()) {
      // handle the invalid form...
    } else {
      $('.newslatter-btn').prop('disabled', true);
      $.ajax({
        type: "POST",
        url: $('.js-validate-form').attr('action'),
        data: $('.js-validate-form').serialize(),
        dataType: 'json',
        success: function(data){
          if(data.status == "success"){

            $('.js-validate-form').hide();
            $('.contact-us-form__title').hide();
            $('.contact-wrap-input').append('<div style="color: white; text-align: center; font-size: 20px; font-weight: 600;" class="js-validate-form-text-after-sending-form">' + data.txt_end + '</div>');

            $('.js-validate-form input[type="radio"], .js-validate-form input[type="checkbox"]').prop('checked', false);
            $('.js-validate-form select option').prop("selected", false);
            $('.newslatter-btn').prop('disabled', false);

            $('.js-validate-form input:not(.js-validate-form--send), .js-validate-form textarea').val("");
  
            setTimeout(function() {

              $('.js-validate-form-text-after-sending-form').remove();
              $('.js-validate-form').show();
              $('.contact-us-form__title').show();
            }, 6000);
          }else{
  
          }
        }
      });
    }
    return false;
  });

});

